function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5,77.3c0-0.867,0.316-1.6,0.95-2.2c0.6-0.6,1.35-0.9,2.25-0.9h83.7  c0.866,0,1.6,0.3,2.199,0.9c0.601,0.6,0.9,1.333,0.9,2.2v14.5c0,0.9-0.3,1.65-0.9,2.25c-0.6,0.6-1.333,0.9-2.199,0.9V95H8.2v-0.05  c-0.9,0-1.65-0.3-2.25-0.9c-0.601-0.6-0.9-1.35-0.9-2.25V77.45L5,77.3z M91.9,5c0.866,0,1.6,0.3,2.199,0.9C94.7,6.5,95,7.233,95,8.1  v14.5c0,0.9-0.3,1.65-0.9,2.25c-0.6,0.6-1.333,0.9-2.199,0.9H8.2c-0.9,0-1.65-0.3-2.25-0.9c-0.601-0.6-0.9-1.35-0.9-2.25V8.25L5,8.1  c0-0.867,0.316-1.6,0.95-2.2C6.55,5.3,7.3,5,8.2,5H91.9z M94.1,40.5c0.601,0.6,0.9,1.333,0.9,2.2v14.5c0,0.9-0.3,1.65-0.9,2.25  c-0.6,0.6-1.333,0.9-2.199,0.9H8.2c-0.9,0-1.65-0.3-2.25-0.9c-0.601-0.6-0.9-1.35-0.9-2.25V42.85L5,42.7c0-0.867,0.316-1.6,0.95-2.2  c0.6-0.6,1.35-0.9,2.25-0.9h83.7C92.767,39.6,93.5,39.9,94.1,40.5z"
});

var SvgList = function SvgList(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef
  }, props), React.createElement("g", null, React.createElement("g", {
    transform: "translate(50 50) scale(0.69 0.69) rotate(0) translate(-50 -50)",
    style: {
      fill: "#000000"
    }
  }, React.createElement("svg", _extends({
    fill: "#000000",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgList, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/list.8f3c3262.svg";
export { ForwardRef as ReactComponent };